// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1yzob","header":"PatientQuestionnaire_header__PLKc3","info":"PatientQuestionnaire_info__14bdZ"};